import { P, match } from 'ts-pattern';
import { implementCustomExpressions } from '../__generated/implementation.js';
import { horizontalHoleCountOptions, verticalHoleCountOptions } from '../data/plate-data.js';
export const getFixingHoleCountUpdate = (size)=>{
    return match(size).with(P.number.gte(2000), ()=>16).with(P.number.gte(1600), ()=>12).with(P.number.gte(1200), ()=>10).with(P.number.gte(800), ()=>8).with(P.number.gte(400), ()=>6).otherwise(()=>4);
};
export const kickPlateFixingHoleExpressions = implementCustomExpressions({
    KickPlateFixingHoles: {
        $availableHorizontalHoleCountOptions: ()=>horizontalHoleCountOptions,
        $availableVerticalHoleCountOptions: ()=>verticalHoleCountOptions,
        $horizontalCount: (s)=>{
            if (s.horizontalCount < 0) {
                return getFixingHoleCountUpdate(s.$plate.$sizeX);
            }
            return s.horizontalCount;
        },
        $verticalCount: (s)=>{
            if (s.verticalCount < 0) {
                return getFixingHoleCountUpdate(s.$plate.$sizeY);
            }
            return s.verticalCount;
        }
    }
});

//# sourceMappingURL=kick-plate-fixing-holes.js.map